import { useEffect, useMemo, useState } from "react";
import { Outlet } from "react-router-dom";

const SCALE_BASE = 1000;

export const AppWrapper = () => {
  const [scale, setScale] = useState(1);

  useEffect(() => {
    const viewport = document.querySelector('meta[name="viewport"]');
    if (viewport) {
      viewport.setAttribute(
        "content",
        "width=device-width, initial-scale=1.0, maximum-scale=1.0, user-scalable=no"
      );
    }
  }, []);

  useEffect(() => {
    const updateScale = () => {
      const { innerWidth, innerHeight } = window;
      const biggestSide = Math.max(innerWidth, innerHeight);
      const nextScale = biggestSide > SCALE_BASE ? biggestSide / SCALE_BASE : 1;

      setScale((prev) =>
        Math.abs(prev - nextScale) > 0.01 ? nextScale : prev
      );
    };

    updateScale();
    window.addEventListener("resize", updateScale);

    return () => window.removeEventListener("resize", updateScale);
  }, []);

  useEffect(() => {
    document.documentElement.style.setProperty("--app-scale", scale.toString());
  }, [scale]);

  const scaledStyle = useMemo(() => {
    const width = Math.min(100 / scale, 100);
    const height = Math.min(100 / scale, 100);

    return {
      transform: `scale(${scale})`,
      transformOrigin: "top left",
      width: `${width}vw`,
      height: `${height}vh`,
      maxWidth: "100vw",
      maxHeight: "100vh",
    };
  }, [scale]);

  return (
    <div
      className="w-screen h-screen min-w-[320px] min-h-[480px] bg-black overflow-hidden"
      style={scaledStyle}
    >
      <Outlet />
    </div>
  );
};
